{
  "MMM Do YYYY, h:mm a": "D. MMM YYYY, HH:mm",
  "MMM Do YYYY": "D. MMM YYYY",
  "Wedding": "Hochzeit",
  "Funeral": "Trauerfeier",
  "Birthday": "Geburtstag",
  "School": "Schule",
  "Sport": "Sport",
  "event type|Other": "Sonstiges",
  "Audio/video professional": "Audio- und Videoprofi",
  "Funeral home owner or director": "Inhaber oder Leitung eines Bestattungsinstituts",
  "Event planner or venue manager": "Eventplaner oder Location-Manager",
  "Church, pastor, preacher or minister": "Kirche, Pastor, Prediger oder Geistlicher",
  "Teacher or school manager": "Lehrkraft oder Schulleitung",
  "Nonprofit or charity": "Gemeinnützige oder karitative Organisation",
  "Live event streamer or producer": "Livestreamer oder Eventproduzent",
  "role|Other": "Sonstiges",
  "room noun|room": "Raum",
  "room noun|stage": "Bühne",
  "room noun|track": "Strecke",
  "room noun|court": "Platz",
  "room noun|field": "Spielfeld",
  "room noun|hall": "Halle",
  "room noun|camera": "Kamera",
  "Sorry, we need camera roll permissions to make this work!": "Wir brauchen leider Zugriff auf deine Fotos, damit das funktioniert.",
  "Streaming Permissions Required": "Berechtigungen zum Streamen erforderlich",
  "EventLive cannot open streaming until camera, microphone, and recording permissions are enabled.": "EventLive kann das Streaming erst öffnen, wenn die Berechtigungen für Kamera, Mikrofon und Aufnahme aktiviert sind.",
  "Search for an event": "Event suchen",
  "Schedule your first service": "Plane deine erste Trauerfeier",
  "Create your first event": "Erstelle dein erstes Event",
  "Each service gets a private link to share with the family. Families watch on any device, with no app or login.": "Jede Trauerfeier bekommt einen privaten Link, den du mit der Familie teilst. Familien schauen auf jedem Gerät zu, ohne App und ohne Anmeldung.",
  "It looks like you have no events at the moment. Create one to see it here": "Du hast im Moment keine Events. Erstelle eins, dann siehst du es hier",
  "Schedule a Service": "Trauerfeier planen",
  "Create an Event": "Event erstellen",
  "You have {count} event credit. Each service day uses one.": {
    "one": "Du hast {count} Event-Credit. Jeder Tag einer Trauerfeier verbraucht einen.",
    "other": "Du hast {count} Event-Credits. Jeder Tag einer Trauerfeier verbraucht einen."
  },
  "You have {count} event credit. Each event day uses one.": {
    "one": "Du hast {count} Event-Credit. Jeder Eventtag verbraucht einen.",
    "other": "Du hast {count} Event-Credits. Jeder Eventtag verbraucht einen."
  },
  "You have {count} prepaid event – it will be used for this event.": {
    "one": "Du hast {count} vorausbezahltes Event – es wird für dieses Event verwendet.",
    "other": "Du hast {count} vorausbezahlte Events – eins davon wird für dieses Event verwendet."
  },
  "Leave": "Verlassen",
  "Keep editing": "Weiter bearbeiten",
  "Leave without scheduling the service?": "Verlassen, ohne die Trauerfeier zu planen?",
  "Leave without scheduling the event?": "Verlassen, ohne das Event zu planen?",
  "Schedule your live fundraiser": "Plane deine Live-Spendenaktion",
  "Schedule a service": "Plane eine Trauerfeier",
  "Schedule your first event": "Plane dein erstes Event",
  "Schedule your event": "Plane dein Event",
  "Next, you'll confirm {organization} as the organization receiving donations. You can change the details later.": "Als Nächstes bestätigst du {organization} als Organisation, die die Spenden erhält. Du kannst die Details später ändern.",
  "Next, you'll choose the organization receiving donations. You can change the details later.": "Als Nächstes wählst du die Organisation, die die Spenden erhält. Du kannst die Details später ändern.",
  "The family gets one private link to watch live or later. You can change the details any time.": "Die Familie bekommt einen privaten Link, um live oder später zuzusehen. Du kannst die Details jederzeit ändern.",
  "You can change the details later.": "Du kannst die Details später ändern.",
  "Are you sure you want to delete {title} and its {count} stage?": {
    "one": "Möchtest du {title} und die zugehörige Bühne wirklich löschen?",
    "other": "Möchtest du {title} und die {count} zugehörigen Bühnen wirklich löschen?"
  },
  "Are you sure you want to delete {title} and its {count} track?": {
    "one": "Möchtest du {title} und die zugehörige Strecke wirklich löschen?",
    "other": "Möchtest du {title} und die {count} zugehörigen Strecken wirklich löschen?"
  },
  "Are you sure you want to delete {title} and its {count} court?": {
    "one": "Möchtest du {title} und den zugehörigen Platz wirklich löschen?",
    "other": "Möchtest du {title} und die {count} zugehörigen Plätze wirklich löschen?"
  },
  "Are you sure you want to delete {title} and its {count} field?": {
    "one": "Möchtest du {title} und das zugehörige Spielfeld wirklich löschen?",
    "other": "Möchtest du {title} und die {count} zugehörigen Spielfelder wirklich löschen?"
  },
  "Are you sure you want to delete {title} and its {count} hall?": {
    "one": "Möchtest du {title} und die zugehörige Halle wirklich löschen?",
    "other": "Möchtest du {title} und die {count} zugehörigen Hallen wirklich löschen?"
  },
  "Are you sure you want to delete {title} and its {count} camera?": {
    "one": "Möchtest du {title} und die zugehörige Kamera wirklich löschen?",
    "other": "Möchtest du {title} und die {count} zugehörigen Kameras wirklich löschen?"
  },
  "Are you sure you want to delete {title} and its {count} room?": {
    "one": "Möchtest du {title} und den zugehörigen Raum wirklich löschen?",
    "other": "Möchtest du {title} und die {count} zugehörigen Räume wirklich löschen?"
  },
  "Could not delete event": "Das Event konnte nicht gelöscht werden",
  "Are you sure you want to delete {title}?": "Möchtest du {title} wirklich löschen?",
  "This action cannot be undone.": "Das kann nicht rückgängig gemacht werden.",
  "Delete Event": "Event löschen",
  "Deleting Event...": "Event wird gelöscht...",
  "Delete {camera}": "{camera} löschen",
  "How to Go Live": "So gehst du live",
  "Guest List & Invite": "Gästeliste & Einladungen",
  "Title, Date, Time, Event Link, Uploads": "Titel, Datum, Uhrzeit, Event-Link, Dateien",
  "Add Another Camera Angle": "Weitere Kameraperspektive hinzufügen",
  "Add a Room, Stage or Track": "Raum, Bühne oder Strecke hinzufügen",
  "Chat": "Chat",
  "Privacy Settings": "Privatsphäre-Einstellungen",
  "Event Branding": "Event-Branding",
  "Event Analytics": "Event-Statistiken",
  "Expiring soon": "Läuft bald ab",
  "Storage expiry": "Ablauf der Speicherung",
  "You're invited to watch {title}": "Du bist eingeladen, {title} anzusehen",
  "Guests use your main link and switch to this camera there. Stream it from its own phone.": "Gäste nutzen deinen Hauptlink und wechseln dort zu dieser Kamera. Streame sie von einem eigenen Smartphone.",
  "Share this link: guests switch between the cameras while they watch. Each camera streams from its own phone.": "Teile diesen Link: Gäste wechseln beim Zusehen zwischen den Kameras. Jede Kamera streamt von einem eigenen Smartphone.",
  "Guests use the main link and switch {noun}s on the event page. This {noun} streams with its own key.": "Gäste nutzen den Hauptlink und wechseln auf der Eventseite zwischen den Streams. Pro {noun} streamst du mit einem eigenen Schlüssel.",
  "Share this link: guests switch {noun}s on the event page. Each {noun} streams with its own key.": "Teile diesen Link: Gäste wechseln auf der Eventseite zwischen den Streams. Pro {noun} streamst du mit einem eigenen Schlüssel.",
  "Your event link:": "Dein Event-Link:",
  "{days}-day event:  Unlock with {count} more credit": {
    "one": "{days}-tägiges Event: mit {count} weiteren Credit freischalten",
    "other": "{days}-tägiges Event: mit {count} weiteren Credits freischalten"
  },
  "Unlock with {count} credit": {
    "one": "Mit {count} Credit freischalten",
    "other": "Mit {count} Credits freischalten"
  },
  "{days}-day event: Unlock with {count} prepaid events": "{days}-tägiges Event: mit {count} vorausbezahlten Events freischalten",
  "{days}-day event: Unlock with your prepaid event": "{days}-tägiges Event: mit deinem vorausbezahlten Event freischalten",
  "Unlock with {count} prepaid events": "Mit {count} vorausbezahlten Events freischalten",
  "Unlock with your prepaid event": "Mit deinem vorausbezahlten Event freischalten",
  "Your private event link is scheduled to expire on {date}. Keep your event page, the video and the guestbook online for 1 more year, or for 10 years.": "Dein privater Event-Link läuft am {date} ab. Halte deine Eventseite, das Video und das Gästebuch noch 1 Jahr länger online – oder 10 Jahre lang.",
  "Keep My Memories Online Longer": "Meine Erinnerungen länger online behalten",
  "Download & View Stats": "Herunterladen & Statistiken ansehen",
  "This Event is in the Secure Archive.": "Dieses Event befindet sich im sicheren Archiv.",
  "The public streaming period for this event has ended. The streaming link has expired, but the memories are safe in our archive.": "Der öffentliche Streaming-Zeitraum für dieses Event ist beendet. Der Streaming-Link ist abgelaufen, aber die Erinnerungen sind in unserem Archiv sicher aufbewahrt.",
  "Restore this Event": "Event wiederherstellen",
  "Unlock cameras": "Kameras freischalten",
  "{days}-Day Event: {start} – {end}": "{days}-tägiges Event: {start} – {end}",
  "Expires in {count} day": {
    "one": "Läuft in {count} Tag ab",
    "other": "Läuft in {count} Tagen ab"
  },
  "Event is in the Secure Archive": "Event befindet sich im sicheren Archiv",
  "Extend": "Verlängern",
  "Use credit": "Credit verwenden",
  "Use prepaid event": "Vorausbezahltes Event verwenden",
  "Could not unlock the event": "Das Event konnte nicht freigeschaltet werden",
  "Pay As You Go": "Ohne Abo",
  "Couldn't schedule the service": "Die Trauerfeier konnte nicht geplant werden",
  "Couldn't schedule the event": "Das Event konnte nicht geplant werden",
  "Service title": "Titel der Trauerfeier",
  "e.g. Celebration of Life for Jane Doe": "z. B. Gedenkfeier für Erika Mustermann",
  "e.g. Anna & Mark's wedding": "z. B. Hochzeit von Anna & Mark",
  "your-event-link": "dein-event-link",
  "Available": "Verfügbar",
  "Event type": "Art des Events",
  "Choose the type of event": "Wähle die Art des Events",
  "When the service starts": "Beginn der Trauerfeier",
  "When the event starts": "Beginn des Events",
  "Make it a multi-day event": "Als mehrtägiges Event planen",
  "Raise donations for a nonprofit": "Spenden für eine gemeinnützige Organisation sammeln",
  "Viewers can donate on your event page. You'll choose the organization after the event is created.": "Zuschauer können auf deiner Eventseite spenden. Die Organisation wählst du, nachdem das Event erstellt ist.",
  "Schedule service": "Trauerfeier planen",
  "Schedule event": "Event planen",
  "Event details": "Eventdetails",
  "{room} follows the main event's date, time and days. Change them there and every {noun} moves with it.": "{room} übernimmt Datum, Uhrzeit und Tage des Hauptevents. Ändere sie dort, dann werden sie automatisch pro {noun} übernommen.",
  "Changes here apply to all {noun}s. Extra days are charged per {noun}.": "Änderungen hier gelten für alle Streams des Events. Zusätzliche Tage werden pro {noun} berechnet.",
  "Title and location": "Titel und Ort",
  "Test events keep their name.": "Test-Events behalten ihren Namen.",
  "e.g. St. Mary's Church, Austin": "z. B. Marienkirche, München",
  "Links and files": "Links und Dateien",
  "Shown under the video on your event page: a registry, a donation page, a website or a program.": "Erscheinen auf deiner Eventseite unter dem Video: eine Wunschliste, eine Spendenseite, eine Website oder ein Programm.",
  "Event rescheduled": "Event verschoben",
  "Guests will see the new date.": "Gäste sehen das neue Datum.",
  "Couldn't change the date": "Das Datum konnte nicht geändert werden",
  "Event date and time": "Datum und Uhrzeit des Events",
  "Choose the event's local date and time": "Wähle das Datum und die Ortszeit des Events",
  "Save date and time": "Datum und Uhrzeit speichern",
  "Change Link": "Link ändern",
  "Change event link?": "Event-Link ändern?",
  "If you've already shared the current link with guests, they won't be able to access the event with the old link anymore. Are you sure you want to proceed?": "Wenn du den aktuellen Link schon mit Gästen geteilt hast, kommen sie mit dem alten Link nicht mehr zum Event. Möchtest du fortfahren?",
  "Event link changed": "Event-Link geändert",
  "Couldn't change the link": "Der Link konnte nicht geändert werden",
  "Share this link with your guests.": "Teile diesen Link mit deinen Gästen.",
  "your-event-name": "name-deines-events",
  "Copy event link": "Event-Link kopieren",
  "Guests who already have the old link won't be able to open the event with it.": "Gäste, die den alten Link schon haben, können das Event damit nicht mehr öffnen.",
  "Change link": "Link ändern",
  "Edit {title}": "{title} bearbeiten",
  "Edit link": "Link bearbeiten",
  "Add a name": "Gib einen Namen ein",
  "Add a web address": "Gib eine Webadresse ein",
  "Open {title}": "{title} öffnen",
  "Open link": "Link öffnen",
  "Remove {title}": "{title} entfernen",
  "Remove link": "Link entfernen",
  "File name guests see": "Dateiname, den Gäste sehen",
  "Link text": "Linktext",
  "e.g. Order of service": "z. B. Ablauf der Trauerfeier",
  "e.g. Our registry": "z. B. Unsere Wunschliste",
  "Web address": "Webadresse",
  "Add link": "Link hinzufügen",
  "File added": "Datei hinzugefügt",
  "Guests can open it from the event page.": "Gäste können sie auf der Eventseite öffnen.",
  "Removed \"{title}\"": "„{title}“ entfernt",
  "Removed \"link\"": "Link entfernt",
  "Tap to undo": "Zum Rückgängigmachen tippen",
  "Uploading…": "Wird hochgeladen…",
  "Upload file": "Datei hochladen",
  "file type|Text": "Text",
  "file type|Image": "Bild",
  "file type|File": "Datei",
  "Document": "Dokument",
  "Add the text guests will see.": "Gib den Text ein, den Gäste sehen.",
  "Add the web address.": "Gib die Webadresse ein.",
  "Enter an address like zola.com/registry or an email.": "Gib eine Adresse wie zola.com/registry oder eine E-Mail-Adresse ein.",
  "Multi-Day event?": "Mehrtägiges Event?",
  "Days": "Tage",
  "Timezone: {timezone}": "Zeitzone: {timezone}",
  "Search timezone...": "Zeitzone suchen...",
  "Select timezone": "Zeitzone auswählen",
  "MMMM D, yyyy h:mm a": "D. MMMM YYYY, HH:mm",
  "dddd, MMMM D, YYYY": "dddd, D. MMMM YYYY",
  "ddd, MMM D": "ddd, D. MMM",
  "Start Time": "Startzeit",
  "Event Date and Local Time": "Datum und Ortszeit des Events",
  "Event Date": "Datum des Events",
  "Select": "Auswählen",
  "date picker|Choose": "Auswählen",
  "date picker|Not available": "Nicht verfügbar",
  "date picker|Month": "Monat",
  "date picker|Previous Month": "Vorheriger Monat",
  "date picker|Next Month": "Nächster Monat",
  "EEEE, MMMM d, yyyy": "EEEE, d. MMMM yyyy",
  "Start time": "Startzeit",
  "h:mm aa": "HH:mm",
  "date picker|time": "Uhrzeit",
  "MMMM d, yyyy h:mm aa": "d. MMMM yyyy, HH:mm",
  "EEE, MMM d": "EEE, d. MMM",
  "Hide the event page? Guests won't be able to open it.": "Eventseite verbergen? Gäste können sie dann nicht mehr öffnen.",
  "Hide the event page?": "Eventseite verbergen?",
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again. {count} person on your guest list will lose access.": {
    "one": "Wer ein Ticket gekauft hat, kann weder den Livestream noch die Aufzeichnung ansehen, bis du die Seite wieder anzeigst. {count} Person auf deiner Gästeliste verliert den Zugang.",
    "other": "Wer ein Ticket gekauft hat, kann weder den Livestream noch die Aufzeichnung ansehen, bis du die Seite wieder anzeigst. {count} Personen auf deiner Gästeliste verlieren den Zugang."
  },
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again.": "Wer ein Ticket gekauft hat, kann weder den Livestream noch die Aufzeichnung ansehen, bis du die Seite wieder anzeigst.",
  "{days}-Day Event: {start}": "{days}-tägiges Event: {start}",
  "This event isn't unlocked yet. Ask an admin of {team}'s account to unlock it.": "Dieses Event ist noch nicht freigeschaltet. Bitte einen Admin des Kontos von {team}, es freizuschalten.",
  "Couldn't load {team}'s events. Try again.": "Die Events von {team} konnten nicht geladen werden. Versuch es noch einmal.",
  "Switch to my account": "Zu meinem Konto wechseln",
  "No events yet": "Noch keine Events",
  "Events in {team}'s account will show up here.": "Hier erscheinen die Events aus dem Konto von {team}.",
  "Event unlocked": "Event freigeschaltet",
  "Couldn't unlock this event": "Dieses Event konnte nicht freigeschaltet werden",
  "{team}'s account may not have enough credits. Ask the account holder to add more.": "Im Konto von {team} sind möglicherweise nicht genug Credits. Bitte den Kontoinhaber, weitere hinzuzufügen."
}
